/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';

import ApiService from 'cio/services/api';
import MailServerModel, { DefaultForType } from 'cio/models/mail-server';
import DS from 'ember-data';
import { EspKey } from 'cio/utils/email-service-providers';
import { CampaignType } from 'cio/models/campaign';

interface ServersTableRowArgs {
  server: MailServerModel;
  servers: MailServerModel[];
  onDelete: (server: MailServerModel) => unknown;
  onEdit: (server: MailServerModel) => unknown;
}

export default class ServersTableRow extends Component<ServersTableRowArgs> {
  @service api!: ApiService;
  @service store!: DS.Store;

  @tracked showConfirmDeleteModal = false;

  EspKey = EspKey;

  readonly defaultItems: { label: string; value: DefaultForType }[] = [
    { label: 'None', value: CampaignType.None },
    { label: 'All Emails', value: 'all' },
    { label: 'Segment Triggered', value: CampaignType.Behavioral },
    { label: 'Event Triggered', value: CampaignType.Transactional },
    { label: 'Newsletters', value: 'newsletter' },
    { label: 'Triggered Broadcasts', value: CampaignType.APITriggered },
    { label: 'Transactional Messages', value: 'transactional_message' },
  ];

  selectServerDefaultTask = task({ drop: true }, async ({ value }: { value: DefaultForType }) => {
    let response = await this.api.post(`mail_servers/${this.args.server.id}/default/${value}`);
    this.store.pushPayload(response);
  });
}
